import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import IconNavigationMenu from '../../../components/IconNavigationMenu';
import TabellaRMAClienti from '../../../components/TabellaRMAClienti';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Check, Close, FastRewind, HourglassEmpty } from '@mui/icons-material';
import ApiService from '../../../components/service/ApiService';
import dayjs from 'dayjs';


const TabelleResi = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const tipoReso = location.state?.tipoReso;

  const [activeTab, setActiveTab] = useState(tipoReso);
  const [datiRMA, setDatiRMA] = useState([]);
  const [filtri, setFiltri] = useState({
    idReso: '',
    numeroFattura: '',
    data: '',
    stato: '',
    descrizione: ''
  });
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const token = user?.token;

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const idCliente = user?.idCliente;


  useEffect(() => {
    const fetchDatiRMA = async () => {
      const paginazione = {
        pagina: 0,
        quantita: 10,
      };
      setLoading(true);
      try {
        // const response = await axios.get(`http://localhost:8080/rma/cliente/${idCliente}`, { headers: headers });
        const response = await ApiService.request("getRmaCliente", {idCliente: idCliente});
          //   const responseGetInvoiceData = await axios.post(
          //     "https://marvinapi-preprod.azurewebsites.net/api/SAT/GetInvoiceData",
          //     {},
          //     {
          //         headers: {
          //             Authorization: headers,
          //             IDCustomerRMT: idCliente,
          //         },
          //     }
          // );

          //   if (responseGetInvoiceData.data?.code === 200) {
          //     // setCustomerData(response.data);
          //     console.log("chiamata OK!!!");
              
          // } else {
          //     console.log("la chiatama a GetInvoiceData non è andata a buon fine");
          // };

          if (response.data && Array.isArray(response.data.rma)) {
              const datiOrdinati = response.data.rma.sort((a, b) => {
                  const dataA = dayjs(a.dataFattura || a.dataRicezioneMerce);
                  const dataB = dayjs(b.dataFattura || b.dataRicezioneMerce);
                  return dataB.diff(dataA); // Ordina dalla più recente alla più vecchia
              });
              setDatiRMA(datiOrdinati);
          } else {
          console.error("I dati ottenuti non sono nel formato Array:", response.data);
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati RMA", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDatiRMA();
  }, []);


  const getTabData = () => {
    return datiRMA.filter((rma) => {
      switch (activeTab) {
        case 'Riparazione':
          return rma.tipologia === 'RIPARAZIONE';
        case 'DOA':
          return rma.tipologia === 'DOA';
        case 'MerceDanneggiata':
          return rma.tipologia === 'ANOMALIA_MERCE_DANNEGGIATA';
        case 'MerceNonConforme':
          return rma.tipologia === 'ANOMALIA_MERCE_NON_CONFORME';
        default:
          return [];
      }
    });
  };

  const steps = [
    t("In attesa"),
    t("In lavorazione"),
    t("Accettato invio cliente"),
    t("Accettato"),
    t("Rimborsato")
  ];

  const handleIconClick = (iconName) => {
    setActiveTab(iconName);
  };

  const dynamicSteps = (step, index, stato) => {
    if (index === 2 && stato === "ACCETTATO_ATTESA_INFO_RITIRO") return "Accettato attesa info ritiro";
    if (index === 3 && stato === "RIFIUTATO") return "Rifiutato";
    if (index === 3 && stato === "RINVIATO") return "Rinviato";

    return step;
  }

  const CustomStepIcon = (stato) => (props) => {
    const { active, completed } = props;

    if (completed) {
      return <Check sx={{ background: '#32976b', color: '#fff', borderRadius: '50%' }} />;
    }

    if (active) {
      switch (stato) {
        case 'IN_ATTESA':
        case 'IN_LAVORAZIONE':
          return <HourglassEmpty sx={{ background: '#FDA03D', color: '#fff', borderRadius: '50%' }} />;
        case 'RINVIATO':
          return <FastRewind sx={{ background: '#FDA03D', color: '#fff', borderRadius: '50%' }} />;
        case 'RIFIUTATO':
          return <Close sx={{ background: '#952828', color: '#fff', borderRadius: '50%' }} />;
        default:
          return <Check sx={{ background: '#32976b', color: '#fff', borderRadius: '50%' }} />;
      }
    }

    return <Check sx={{ background: '#ccc', color: '#fff', borderRadius: '50%' }} />;
  };


  return (
    <Container maxWidth="false">
      <Typography sx={{
        ml: 6,
        mt: 1,
        fontWeight: 'bold',
        fontSize: '3em',
        color: '#FDA03D',
      }}
      >
        {t('Gestione Resi')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', pl: 4, pr: 4 }}>
        <IconNavigationMenu onIconClick={handleIconClick} activeTab={activeTab} />
      </Box>

      <Container maxWidth={false} sx={{ display: 'flex', flexDirection: 'column', pt: 1 }}>
        <TabellaRMAClienti
          data={getTabData()}
          loading={loading}
          steps={steps}
          filtri={filtri}
          setFiltri={setFiltri}
          dynamicSteps={dynamicSteps}
          customStepIcon={(stato) => CustomStepIcon(stato)}
        />
      </Container>
    </Container>
  );
};

export default TabelleResi;
